// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ifCh","empty":"ModalGraph_empty__1YBe6"};